import { normalizeMatchLayout } from 'modules/manager/domain/match-layout';
import { normalizePlayerRanking } from 'modules/manager/domain/player-stats';
import { DEFAULT_TEMPLATE_TYPE, TemplateType, isKnownTemplateType } from 'modules/manager/domain/template-type';
import { MediaManagerTemplateGql } from 'modules/manager/domain/graphql/media-manager-templates';
import { MediaManagerTemplate } from '../interfaces/supabase/media-manager/entity';

const mediaManagerTemplateDataMapper = (template: MediaManagerTemplateGql): MediaManagerTemplate => {
  return {
    id: template.id,
    name: template.name,
    objects: template.objects ?? [],
    version: template.version,
    order: template.order,
    width: template.width,
    height: template.height,
    tournamentId: template.tournamentId ?? null,
    templateGroupId: template.templateGroupId,
    sportType: template.sportType as MediaManagerTemplate['sportType'],
    templateType: coerceTemplateType(template.templateType),
    templateSubtypes: Array.isArray(template.templateSubtypes) ? template.templateSubtypes : [],
    matchLayout: normalizeMatchLayout(template.matchLayout),
    playerRanking: normalizePlayerRanking(template.playerRanking),
    createdAt: template.createdAt,
    updatedAt: template.updatedAt,
  };
};

function coerceTemplateType(value: unknown): TemplateType {
  if (isKnownTemplateType(value as string | undefined | null)) {
    return value as TemplateType;
  }
  if (value !== undefined && value !== null && value !== '') {
    // eslint-disable-next-line no-console
    console.warn(`[media-manager] unknown template_type "${value}" — falling back to "${DEFAULT_TEMPLATE_TYPE}"`);
  }
  return DEFAULT_TEMPLATE_TYPE;
}

export default mediaManagerTemplateDataMapper;
